<template>
  <div class="sdk_list_container">
    <div class="sdk_list_box">
      <div class="h2">
        <span>第三方SDK目录</span>
      </div>
      <p class="desc">为保障飞鸿App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。</p>
      <p class="desc">我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。 我们对接入的相关第三方SDK在以下目录中列明。</p>
     <div class="h4">
        <span>华为推送 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：推送消息</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://developer.huawei.com/consumer/cn/service/hms/pushservice.html">https://developer.huawei.com/consumer/cn/service/hms/pushservice.html</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>小米推送 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：推送消息</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>极光推送 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：推送消息</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.jiguang.cn/push">https://www.jiguang.cn/push</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>极光认证 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：社会化分享</span></p>
        </li>
        <li>
          <p><span>数据类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/IP/地理位置）、应用列表</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>友盟统计 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：数据统计</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.umeng.com/analytics">https://www.umeng.com/analytics</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>百度地图 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：用户发表信息时显示所在位置</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息、地理位置信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://lbsyun.baidu.com/">https://lbsyun.baidu.com/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>七牛云对象存储 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：用户上传图片视频</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息、图片或视频文件</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.qiniu.com/products/kodo">https://www.qiniu.com/products/kodo</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>阿里路由 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：解析接口数据渲染页面</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://github.com/alibaba/ARouter/tree/master">https://github.com/alibaba/ARouter/tree/master</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>腾讯TBS浏览服务</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：提高新闻页webview的用户浏览体验</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://x5.tencent.com/tbs/guide/sdkInit.html">https://x5.tencent.com/tbs/guide/sdkInit.html</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>腾讯bugly</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：统计应用的崩溃信息日志</span></p>
        </li>
        <li>
          <p><span>数据类型：设备识别信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://bugly.qq.com/v2/">https://bugly.qq.com/v2/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>微信 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span></p>
        </li>
        <li>
          <p><span>数据类型：设备信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>微博 SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span></p>
        </li>
        <li>
          <p><span>数据类型：设备信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.weibo.com/development/mobile">https://open.weibo.com/development/mobile</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>QQ SDK</span>
      </div>
      <ul>
        <li>
          <p><span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span></p>
        </li>
        <li>
          <p><span>数据类型：设备信息</span></p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.tencent.com/">https://open.tencent.com/</a></span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
export default {
  name: "SDKList",
  data() {
    return {
      pageData: {
        title: "第三方SDK目录",
        info: "",
        shareUrl: "",
        imageUrl: "",
      },
    };
  },
  computed: {
    ...mapState("app", ["shareRootUrl", "appFullName"]),
  },
  methods: {},
  created() {
    document.title = this.pageData.title;
    loadStat(); // 友盟统计
    this.pageData.info = this.appFullName;
    this.pageData.shareUrl = this.shareRootUrl + "sdk_list";
    this.pageData.imageUrl = this.shareRootUrl.replace("/#/", "/") + require('@/assets/images/logo/logo.png');
  },
  mounted() {
    var _this = this;
    window.setShareInfo = () => {
      var shareStr = JSON.stringify(_this.pageData);
      // 调用客户端方法，将分享信息传给客户端
      if (window.java) {
        window.java.setShareInfo(shareStr);
      } else {
        _this.$bridge.callhandler("setShareInfo", shareStr, (data) => { });
      }
    }
  },
};
</script>
<style scoped lang="scss">
.sdk_list_container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #000;
  display: flex;
  flex-direction: column;
  .sdk_list_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: break-all;
      white-space: normal;
      line-height: 1.5em;
    }
    .h2 {
      padding: 18px 0;
      font-size: 18px;
      font-weight: bolder;
      text-align: center;
    }
    .h4 {
      margin-top: 15px;
      font-size: 16px;
      font-weight: bolder;
    }
    ul {
      li {
        margin-left: 20px;
        list-style-type: disc;
        p {
          color: #000;
          font-size: 16px;
          font-family: "宋体";
          span {
            font-size: 16px;
            font-family: "宋体";
            a {
              text-decoration: underline;
              font-family: "宋体";
            }
          }
        }
      }
    }
  }
}
</style>